module.exports = __webpack_public_path__ + "img/ic_tripadvisor-3.0.366b2bd3.svg";